import { ReactNode } from 'react';

import CustomModal from './CustomModal';

const TooltipModal = ({
  title,
  content,
  subtext,
  isOpen,
  handleClose,
  header,
}: {
  title: string;
  content: string;
  subtext: string;
  isOpen: boolean;
  handleClose: () => void;
  header?: ReactNode;
}) => {
  return (
    <CustomModal
      content={
        <div>
          <div className={`flex h-24 items-center justify-center`}>{header}</div>
          <div className="px-8 pb-10">
            <p className="pt-4 pb-2 text-lg font-semibold">{title}</p>
            <div className="flex flex-col gap-4 text-gray-700">
              <p>{content}</p>
              <p className="border border-x-0 border-b-0 pt-4 text-sm text-gray-500">{subtext}</p>
            </div>
          </div>
        </div>
      }
      isOpen={isOpen}
      handleClose={handleClose}
    />
  );
};

export default TooltipModal;
